export default "__VITE_ASSET__CpwrRIR0__"